<script>
export default {
    name: 'IconUpload'
}
</script>
<template>
    <svg
        class="base-icon icon-upload"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 52H12v4h40v-4zm-5-29.12L32.117 8.115 32 8l-.117.116L17 22.879l4.93 4.873 6.552-6.497V40h7.037V21.255l6.55 6.497L47 22.879z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
